import { addListener } from "@grindex-common/helpers/domManipulation";
import { ProductPageTabView } from "@grindex-client/components/Tabs/TabView.ProductPage.class";
import { baseLink } from "@grindex-common/helpers/baseLink";

function init($views) {
	const ROUTES = {
		"/": "overview",
		"/specifications/": "specifications",
		"/curves/": "curves",
		"/technicalsoftware/": "technicalsoftware",
		"/drawings/": "drawings",
		"/components/": "components",
		"/accessories/": "accessories",
		"/applications/": "applications",
		"/documentation/": "documentation",
		"/technology/": "technology",
		"/submittals/": "submittals",
		"/faq/": "faq",
		"*default": "overview",
	};

	$views.forEach(($productTab) => {
		const tabView = new ProductPageTabView(baseLink.getBaseLinkWithoutSegments(window.config.tabs), ROUTES, $productTab);

		tabView.init();

		const $sidebarCommerceButton = document.querySelector(".sidebar-commerce-button");

		addListener($sidebarCommerceButton, commerceButtonClick);

		function commerceButtonClick() {
			document.querySelector("span[data-tab='2']").dispatchEvent(new Event("click"));
		}
	});
}

export default {
	view: "product-tabs",
	init,
};
